/**
 * Created by Jerker Nord on 2020-05-26.
 */
import {IScreenViewConfig, ScreenView} from "@nolimitcity/slot-game/bin/core/screen/ScreenView";
import {IResizeData} from "@nolimitcity/slot-game/bin/core/stage/StageManager";
import {Linear, TimelineLite, TweenLite} from "gsap";
import {MonkeysGoldFreeSpinOutroController} from "./MonkeysGoldFreeSpinOutroController";
import {MonkeysGoldParsedGameData} from "../../server/data/MonkeysGoldParsedGameData";
import {GameResources} from "@nolimitcity/slot-game/bin/core/resource/GameResources";
import {SpineTween} from "@nolimitcity/slot-game/bin/core/animation/SpineTween";
import {INolimitAudioPlayer} from "@nolimitcity/slot-audio/bin/INolimitAudioPlayer";
import {SlotGame} from "@nolimitcity/slot-game/bin/core/SlotGame";
import {MonkeysGoldSoundConfig} from "../../MonkeysGoldSoundConfig";
import {MonkeysGoldGameModuleConfig} from "../../MonkeysGoldGameModuleConfig";
import {MonkeysGoldInitialWinCountUp} from "../../winpresentation/initial/MonkeysGoldInitialWinCountUp";
import {BitmapTextStyleOptions} from "@nolimitcity/slot-game/bin/core/text/BitmapTextStyleOptions";
import {WinRatioType} from "@nolimitcity/slot-game/bin/core/winpresentation/WinRatio";
import {FontStyle, FontWeight} from "@nolimitcity/slot-launcher/bin/loader/font/FontStatics";
import {Translation} from "@nolimitcity/slot-game/bin/core/translation/Translation";

export class MonkeysGoldFreeSpinOutroView extends ScreenView {

    protected readonly DEFAULT_MOBILE_SCALE:number = 1;
    protected readonly DEFAULT_PORTRAIT_SCALE:number = 1;

    private _blackGfx:PIXI.Graphics;
    private _darkenBackground:PIXI.Graphics;
    private _container:PIXI.Container;
    private _onShowComplete:() => void;
    private _spineOutro:PIXI.spine.Spine;
    private _winCountUpYellow:MonkeysGoldInitialWinCountUp;
    private _clicker:PIXI.Graphics;
    private _outroTL:TimelineLite;
    private _countUpTL:TimelineLite;
    private _totalWin:number;
    private _countUpStyle:BitmapTextStyleOptions = {
        font : {
            name : "NumbersWinCountUp",
            size : 50
        }
    };
    private _youWonText:PIXI.Text;
    private _style = new PIXI.TextStyle({
        fontFamily : "Open Sans",
        fontSize : "50px",
        fill : "#e4e1c8",
        fontStyle : FontStyle.NORMAL,
        fontWeight : FontWeight.BOLD,
        dropShadow : true,
        dropShadowAlpha : 1,
        dropShadowAngle : Math.PI * 0.5,
        dropShadowBlur : 8,
        dropShadowColor : "#000000",
        dropShadowDistance : 3,
        padding : 20
    });
    private _belowStakeWinRestriction:boolean;

    constructor(config:IScreenViewConfig, autoClose:boolean = true) {
        super(config, autoClose);
        this._winCountUpYellow = new MonkeysGoldInitialWinCountUp(this._countUpStyle);
    }

    protected initAnimations():void {
        super.initAnimations();

        this._blackGfx = new PIXI.Graphics();
        this._blackGfx.alpha = 0;
        this.addChild(this._blackGfx);

        this._clicker = new PIXI.Graphics();
        this._clicker.on('pointertap', () => this.onAbortClick(), this);
        this._clicker.interactive = true;
        this._clicker.buttonMode = true;
    }

    private onAbortClick():void {
        this.removeChild(this._clicker);
        if(this._outroTL && this._outroTL.isActive()) {
            this._outroTL.pause();
            this._outroTL.kill();
        }
        this.alpha = 1;
        this._winCountUpYellow.getBitmapCountUp().getCountUpAnimation(this._totalWin, this._totalWin, {duration : 0.01});
        (<INolimitAudioPlayer>SlotGame.sound).stopTrack(MonkeysGoldSoundConfig.instance.COUNTUP);
        (<INolimitAudioPlayer>SlotGame.sound).playTrack({
            name : (MonkeysGoldSoundConfig.instance.COUNTUP_ENDS_SMALL)
        });
        this._onShowComplete();
    }

    protected setButtonPosition(data:IResizeData):void {
        super.setButtonPosition(data);
        this._button.position.y = ((data.height - 720) / 2) + 596;
    }

    public enableButton() {
        this._button.visible = true;
        super.enableButton();
    }

    protected createGameGraphics():PIXI.DisplayObject {
        const cont:PIXI.Container = new PIXI.Container();

        this._darkenBackground = new PIXI.Graphics();
        this._darkenBackground.alpha = 0.5;

        this._spineOutro = new PIXI.spine.Spine(GameResources.getSpineAsset("spineBonusGameIntro"));
        this._spineOutro.position.set(0, 0);
        this._spineOutro.visible = false;

        this._youWonText = new PIXI.Text(Translation.translate("YOU WON"), this._style);
        this._youWonText.anchor.set(0.5, 0.5);
        this._youWonText.position.set(0, -60);

        this._winCountUpYellow.position.set(0, 40);

        cont.addChild(this._darkenBackground);
        cont.addChild(this._spineOutro);
        cont.addChild(this._winCountUpYellow);
        cont.addChild(this._youWonText);

        this._container = cont;
        return this._container;
    }

    protected onResize(resizeData:IResizeData):void {
        super.onResize(resizeData);
        this.position.x = 0 - (Math.ceil(resizeData.width / this._layer.scale.x) - 720) / 2;
        this.position.y = 0 - (Math.ceil(resizeData.height / this._layer.scale.y) - 720) / 2;

        this._screenWidth = Math.ceil(resizeData.width / this._layer.scale.x);
        this._screenHeight = Math.ceil(resizeData.height / this._layer.scale.y);

        const leftOffset:number = Math.floor(-this._layer.x / this._layer.scale.x);
        const topOffset:number = Math.floor(-this._layer.y / this._layer.scale.y);
        this._clicker.clear();
        this._clicker.beginFill(0xFF0000, 1);
        this._clicker.alpha = 0;
        this._clicker.drawRect(leftOffset, topOffset, this._screenWidth, this._screenHeight);
    }

    protected onResizeGameGraphics(resizeData:IResizeData):void {
        this._container.position.set(this._screenWidth * 0.5, this._screenHeight * 0.5);

        this._blackGfx.clear();
        this._blackGfx.beginFill(0x000000);
        this._blackGfx.drawRect(0, 0, this._screenWidth, this._screenHeight);
        this._blackGfx.endFill();

        this._darkenBackground.clear();
        this._darkenBackground.beginFill(0x000000);
        this._darkenBackground.drawRect(0, 0, this._screenWidth, this._screenHeight);
        this._darkenBackground.endFill();
        this._darkenBackground.position.set(-this._darkenBackground.width * 0.5, -this._darkenBackground.height * 0.5);
    }

    protected startPresentation(data:MonkeysGoldParsedGameData, onShowComplete?:() => void):void {
        this._totalWin = data.totalWin;
        this._onShowComplete = onShowComplete!;
        this._button.visible = false;
        //this._belowStakeWinRestriction = SlotGame.api.gameClientConfiguration.belowStakeWinRestriction && (data.totalWin <= data.playedBetValue);
        this._belowStakeWinRestriction = MonkeysGoldGameModuleConfig.featurePrice.isWinBelowStake();

        this.alpha = 0;
        this._blackGfx.alpha = 0;
        this._container.alpha = 1;
        this._button.alpha = 1;
        this._youWonText.visible = !this._belowStakeWinRestriction;
        if(this._autoCloseTimer) {
            this._autoCloseTimer.alpha = 1;
        }

        MonkeysGoldGameModuleConfig.monkeysGoldRowLockWPController.cleanUp();
        MonkeysGoldGameModuleConfig.monkeysGoldRowLockView.resetAllAnimations();

        this._outroTL = new TimelineLite();
        this._outroTL.add([
            new TweenLite(this, 1, {alpha : 1, ease : Linear.easeNone}),
            () => this._spineOutro.updateTransform(),
            () => this._spineOutro.visible = true,
            () => this._spineOutro.skeleton.setSlotsToSetupPose(),
            new SpineTween(this._spineOutro, 0, "landscape_animation", 0),
            () => (<INolimitAudioPlayer>SlotGame.sound).playTrack({name : (MonkeysGoldSoundConfig.instance.FS_OUTRO)}),
            new TimelineLite({delay : 0.262}).add(() => (<INolimitAudioPlayer>SlotGame.sound).stopTrack(MonkeysGoldSoundConfig.instance.BONUS_GAME_MUSIC)),
            new TimelineLite({delay : 0.262}).add(() => (<INolimitAudioPlayer>SlotGame.sound).playTrack({ name : MonkeysGoldSoundConfig.instance.BACKGROUND_MUSIC[0],volume : 0})),
            new TimelineLite({delay : 0.262}).add(() => (<INolimitAudioPlayer>SlotGame.sound).fadeTrack({
                name : MonkeysGoldSoundConfig.instance.BACKGROUND_MUSIC[0],
                duration : 5000,
                from : 0,
                to : 1
            })),
            this.getCountUpTimeLine()
        ], "+=2");

        this._outroTL.add(() => this._spineOutro.state.setAnimation(0, "Loop_animation", true));
        this._outroTL.add(this._winCountUpYellow.getBitmapCountUp().getCountUpAnimation(data.totalWin, data.totalWin, {duration : 0.01}));
        if(onShowComplete) {
            this._outroTL.add(() => this.removeChild(this._clicker));
            this._outroTL.add(() => {onShowComplete()});
        }
    }

    private getCountUpTimeLine():TimelineLite {
        this._countUpTL = new TimelineLite();
        this._countUpTL.add([
            () => this._winCountUpYellow.currentWinRatio = WinRatioType.LARGE,
            () => this.addChild(this._clicker)
        ], "+=0.27");//Gives the music time to change before we activate the abortable
        if(this._totalWin > 0 && !this._belowStakeWinRestriction) {
            this._countUpTL.add(() => (<INolimitAudioPlayer>SlotGame.sound).playTrack({
                name : (MonkeysGoldSoundConfig.instance.COUNTUP),
                repeat : 0
            }));
            this._countUpTL.add(this._winCountUpYellow.getCountUpAnimation(0, this._totalWin, 1.688, 1, WinRatioType.LARGE));
        }
        this._countUpTL.add(() => this.removeChild(this._clicker));
        this._countUpTL.add(() => this._winCountUpYellow.getBitmapCountUp().visible = true);
        this._countUpTL.add(() => this._winCountUpYellow.getBitmapCountUp().getCountUpAnimation(this._totalWin, this._totalWin, {duration : 0.01}));
        this._countUpTL.add(() => (<INolimitAudioPlayer>SlotGame.sound).stopTrack(MonkeysGoldSoundConfig.instance.COUNTUP));

        if (!this._belowStakeWinRestriction){
            this._countUpTL.add(() => (<INolimitAudioPlayer>SlotGame.sound).playTrack({
                name : (MonkeysGoldSoundConfig.instance.COUNTUP_ENDS_SMALL)
            }));
        }


        this._countUpTL.add(() => this._onShowComplete());

        return this._countUpTL;
    }

    protected stopPresentation(closeCallback?:() => void):void {
        const timeline:TimelineLite = new TimelineLite();
        timeline.add(this.fadeInBlack());
        timeline.add(() => {
            this._container.alpha = 0;
            MonkeysGoldGameModuleConfig.featurePrice.reset();
            this._button.alpha = 0;
            if(this._autoCloseTimer) {
                this._autoCloseTimer.alpha = 0;
            }
        });
        timeline.add(() => MonkeysGoldFreeSpinOutroController.actuallyDoTransition());
        timeline.add(new TweenLite(this, 1, {alpha : 0, ease : Linear.easeNone}));
        timeline.add(() => super.stopPresentation(closeCallback));
    }

    private fadeInBlack():TimelineLite {
        const tl:TimelineLite = new TimelineLite();
        tl.add(new TweenLite(this._blackGfx, 1, {alpha : 1, ease : Linear.easeNone}));
        return tl;
    }
}